<template>
    <div>
        <!-- 查看弹框-->
        <el-form :model="lookform" label-width="180px">
            <el-form-item label="服务主题：">
                <el-input
                    v-model="lookform.activityTheme"
                    class="form_input"
                    :disabled="readonly"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <el-form-item label="服务内容：">
                <el-input
                    v-model="lookform.serviceContent"
                    class="form_input"
                    :disabled="readonly"
                    autocomplete="off"
                    type="textarea"
                    :row="4"
                ></el-input>
            </el-form-item>
            <el-form-item label="参加人员：">
                <el-table
                    :data="tableData"
                    highlight-current-row
                    style="width: 80%; margin-top: 16px"
                    border
                >
                    <el-table-column
                        label="序号"
                        type="index"
                        align="center"
                        width="50"
                    ></el-table-column>
                    <el-table-column
                        prop="name"
                        align="center"
                        label="姓名"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        prop="sex"
                        align="center"
                        width="50"
                        label="性别"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.sex == 0">男</span>
                            <span v-if="scope.row.sex == 1">女</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="idCode"
                        align="center"
                        label="身份证号"
                        width="150"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        prop="address"
                        align="center"
                        label="家庭地址"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        prop="phone"
                        align="center"
                        label="联系电话"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        prop="education"
                        align="center"
                        width="70"
                        label="学历"
                        :show-overflow-tooltip="true"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.degreeOfEducation == 0"
                                >初中</span
                            >
                            <span v-if="scope.row.degreeOfEducation == 1"
                                >高中</span
                            >
                            <span v-if="scope.row.degreeOfEducation == 2"
                                >职校</span
                            >
                            <span v-if="scope.row.degreeOfEducation == 3"
                                >专科</span
                            >
                            <span v-if="scope.row.degreeOfEducation == 4"
                                >本科</span
                            >
                            <span v-if="scope.row.degreeOfEducation == 5"
                                >研究生</span
                            >
                            <span v-if="scope.row.degreeOfEducation == 6"
                                >博士</span
                            >
                            <span v-if="scope.row.degreeOfEducation == 7"
                                >其他</span
                            >
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="operation"
                        label="操作"
                        align="center"
                        width="80px"
                        fixed="right"
                    >
                        <template scope="scope">
                            <el-tooltip
                                class="item"
                                effect="light"
                                content="查看"
                                placement="top-start"
                            >
                                <button
                                    style="color: skyblue"
                                    class="iconfont icon-chakan tabBtn"
                                    @click="lookPersonDetail(scope.row.id)"
                                ></button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 分页功能 -->
                <el-pagination
                    :page-size="pageConfig.pageSize"
                    layout="total, prev, pager, next, jumper"
                    @current-change="handleCurrentChange"
                    :total="pageConfig.total"
                ></el-pagination>
            </el-form-item>
            <el-form-item label="活动总结：">
                <el-input
                    :disabled="readonlyAll"
                    v-model="addForm.activitySummary"
                    class="form_input"
                    autocomplete="off"
                    type="textarea"
                    :row="4"
                ></el-input>
            </el-form-item>
            <el-form-item label="上传附件：">
                <el-upload
                    class="upload-demo form_input"
                    :action="actionUrl"
                    :disabled="readonlyAll"
                    :on-remove="
                        (file, fileList) =>
                            handleRemove('attachment', file, fileList)
                    "
                    :before-remove="beforeRemove"
                    :on-success="(data) => fileSuccess('attachment', data)"
                    multiple
                    :limit="9"
                    :on-exceed="handleExceed"
                    :file-list="activityPlan"
                >
                    <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
            </el-form-item>
            <el-form-item>
                <div class="footer">
                    <el-button
                        v-if="readonlyAll != true"
                        type="primary"
                        @click="editSave()"
                        >保 存</el-button
                    >
                    <el-button type="info" @click="clearForm()"
                        >取 消</el-button
                    >
                </div>
            </el-form-item>
        </el-form>
        <!--查看人员弹框-->
        <el-dialog
            title="查看"
            :visible.sync="dialogFormVisible"
            width="995px"
            append-to-body
        >
            <el-form
                :model="lookPersonForm"
                label-width="180px"
                style="position: relative"
            >
                <el-form-item label="姓名：">
                    <el-input
                        class="form_input1"
                        disabled
                        v-model="lookPersonForm.name"
                    ></el-input>
                </el-form-item>
                <el-form-item label="性别：">
                    <el-select
                        class="form_input1"
                        disabled
                        v-model="lookPersonForm.sex"
                        placeholder="请选择"
                    >
                        <el-option label="男" value="0"></el-option>
                        <el-option label="女" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="出生年月：" prop="name">
                    <el-date-picker
                        style="width: 300px"
                        disabled
                        v-model="lookPersonForm.birth"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="选择出生年月"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="身份证号：" prop="idCode">
                    <el-input
                        class="form_input1"
                        disabled
                        v-model="lookPersonForm.idCode"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item label="联系电话：" prop="phone">
                    <el-input
                        class="form_input"
                        disabled
                        v-model="lookPersonForm.phone"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item label="文化程度：">
                    <el-select
                        class="form_input"
                        disabled
                        v-model="lookPersonForm.education"
                    >
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="家庭地址：">
                    <el-input
                        class="form_input"
                        disabled
                        v-model="lookPersonForm.address"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item label-width="0px;width: 200px;" class="toux">
                    <img
                        alt
                        :src="
                            lookPersonForm.photo == null
                                ? egImg
                                : lookPersonForm.photo
                        "
                        style="
                            width: 170px;
                            height: 150px;
                            vertical-align: top;
                            margin-left: 10px;
                        "
                    />
                    <div style="text-align: center; width: 200px">头像</div>
                </el-form-item>
                <el-form-item>
                    <div class="footer">
                        <el-button type="info" @click="clearPersonForm()"
                            >取 消</el-button
                        >
                    </div>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { post } from "@/api/requrestHttp.js"
import request from "@/utils/request.js"
import baseURL from "@/api/baseURL"
export default {
    props: ["rowid", "readonlyjg", "readonlys", "readonlyAll"],
    data() {
        return {
            id: this.rowid,
            readonly: this.readonlys,
            readonlyzj: this.readonlyjg,
            egImg: require("../../../assets/images/partyMemberManagementcopy/imgjia.png"),
            url:baseURL+
                "/ypt/controller/uploadVotePic/info/uploadPartyPhoto",
            actionUrl:baseURL+
                 "/ypt/controller/uploadVotePic/info/uploadPartyPhoto",
            lookDialogVisible: false,
            activityTimes: [],
            lookform: {},
            platformcheckList: [],
            socialOrgOptions: [],
            fileList: [],
            activityPlan: [],
            // 所有附件名集合
            fileTitleList: [],
            addForm: {
                attachment: [],
            },
            lookPersonForm: {},
            tableData: [],
            options: [
                { label: "初中", value: "0" },
                { label: "高中", value: "1" },
                { label: "职校", value: "2" },
                { label: "专科", value: "3" },
                { label: "本科", value: "4" },
                { label: "研究生", value: "5" },
                { label: "博士", value: "6" },
                { label: "其他", value: "7" },
                { label: "职校", value: "8" },
            ],
            pageConfig: {
                pageNo: 1,
                pageSize: 5,
                total: 0,
            },
            checkList: [],
            dialogFormVisible: false,
        }
    },
    methods: {
        //分页
        handleCurrentChange(val) {
            this.pageConfig.pageNo = val
            this.getServiceItemsPerson()
        },
        //上传图片方法
        async upImgEdit(e) {
            if (e.target.files[0] == undefined) {
                return false
            } else {
                let res = await uploadPartyPhoto(e.target.files[0])
                this.editform.photo = res.content
            }
        },
        // 关闭查看人员弹框
        clearPersonForm() {
            this.dialogFormVisible = false
            this.lookPersonForm = {}
            this.checkList = []
        },
        // 获取参加人员详情
        lookPersonDetail(Pid) {
            this.dialogFormVisible = true
            this.checkList = []
            if (Pid) {
                post("/admin/serviceItemsPerson/info/getServiceItemsPerson", {
                    id: Pid,
                }).then((res) => {
                    if (res.code == 200) {
                        this.lookPersonForm = res.content
                        console.log("lookPersonForm", this.lookPersonForm)
                    } else {
                        this.$message({
                            message: "获取参加人员详情失败",
                            type: "error",
                        })
                    }
                })
            }
        },
        // 获取参加人员列表
        getServiceItemsPerson() {
            this.tableData = []
            console.log("rowid", this.rowid)
            post("/admin/serviceItemsPerson/info/listServiceItemsPerson", {
                serviceItemsId: this.rowid,
                pageNo: this.pageConfig.pageNo,
                pageSize: this.pageConfig.pageSize,
            }).then((res) => {
                if (res.code == 200) {
                    this.tableData = res.content.list
                    this.pageConfig.total = res.content.count
                }
            })
        },
        //附件上传
        handleExceed(files, fileList) {
            var selected = files.length
            var totalselected = selected + fileList.length
            this.$message.warning(
                "当前限制选择3个文件，本次选择了" +
                    selected +
                    "个文件，共选择了" +
                    totalselected +
                    "个文件"
            )
        },
        //确保每次只能上传一个文件，可多次上传
        uploadSuccess(response, file, fileList) {
            console.log(response)
            if (response.code == 200) {
                this.fileList.push({
                    name: response.content.name,
                    url: response.content.path,
                })
            }
        },
        handleRemove(file, fileList) {
            this.fileList = fileList
        },
        //附件预览
        handlePreview(file) {
            window.open(file.url)
        },
        // 修改保存
        editSave(id) {
            // 处理附件
            this.handleFilePost()
            console.log(this.addForm)
            post("/admin/serviceItems/info/updateServiceItems", {
                id: this.id,
                ...this.addForm,
                activityStatus: "6",
            }).then((res) => {
                if (res.code == 200) {
                    this.$message({ message: "修改成功", type: "success" })
                    this.dialogFormVisibleTwo = false
                    this.clearForm()
                } else {
                    this.$message({ message: "修改失败", type: "error" })
                }
            })
        },
        //上传文件方法
        handleRemove(type, file, fileList) {
            this.addForm.attachment.map((item, index) => {
                if (file.response != undefined) {
                    if (item == file.response.content) {
                        this.addForm.attachment.splice(index, 1)
                    }
                } else {
                    if (item == file.url) {
                        this.addForm.attachment.splice(index, 1)
                    }
                }
            })
            console.log(this.addForm.attachment)
        },
        // 移除文件
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`)
        },
        // 文件上传成功
        fileSuccess(type, data) {
            if (data.code === 200) {
                console.log(this.addForm.attachment)
                this.addForm.attachment.push(data.content)
            }
            console.log(this.addForm.attachment)
        },
        // 文件超出限制数量
        handleExceed(files, fileList) {
            this.$message.warning(
                `当前限制选择 9个文件，本次选择了 ${
                    files.length
                } 个文件，共选择了 ${files.length + fileList.length} 个文件`
            )
        },
        // 发送时处理附件
        handleFilePost() {
            console.log("this.addForm.attachment", this.addForm.attachment)
            this.addForm.attachment.forEach((element, index) => {
                let str = ""
                if (
                    this.addForm.attachment &&
                    Array.isArray(this.addForm.attachment)
                ) {
                    this.addForm.attachment.map((item, index) => {
                        str += item.path + "#"
                        console.log(str)
                    })
                } else {
                    str = this.addForm.attachment
                }
                this.addForm.attachment = str
            })
            console.log("this.addForm.attachment", this.addForm.attachment)
        },
        clearForm() {
            this.lookform = {}
            this.addForm = {}
            this.activityPlan = []
            this.$emit("close")
            console.log("9999")
        },
        closeLookProject() {
            this.showcheck = false
        },
        getData() {
            console.log("getData")
            this.lookform = {}
            this.fileList = []
        },
        getDetail() {
            console.log("getDetail", this.id, "++++", this.readonlyjg)
            if (this.id) {
                post("/admin/serviceItems/info/getServiceItems", {
                    id: this.id,
                }).then((res) => {
                    this.getServiceItemsPerson()
                    this.lookform = res.content
                    console.log("lookform", this.lookform)
                })
            }
        },
    },
    mounted() {
        console.log("info", this.rowid, "++", this.readonlyAll)
        this.getDetail()
    },
}
</script>

<style lang="less">
.form_input {
    width: 600px;
}
.el-form-item {
    margin-top: 20px;
}
.footer {
    text-align: center;
    margin-left: -140px;
}
.form_input1 {
    width: 300px;
}
.toux {
    width: 300px;
    position: absolute;
    right: 7%;
    top: -5px;
}
.threestyleimg {
    display: flex;
    flex-wrap: wrap;
    .threestyleimgtu {
        width: 80%;
        height: 70%;
        display: flex;
    }
    .threestyleimgbtn {
        width: 80%;
        height: 30%;
        margin-top: 20px;
        display: flex;
        position: relative;
        div {
            width: 170px;
            height: 30%;
            background: #ffffff;
            border: 1px solid #cad4dc;
            text-align: center;
            line-height: 30px;
        }
        input {
            position: absolute;
            width: 172px;
            height: 32px;
            opacity: 0;
            cursor: pointer;
        }
    }
}
</style>